// ============================================================================
// DropdownListGroup.jsx — Corelia v1.2
// Regroupe plusieurs DropdownList en vertical ou horizontal
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";
import DropdownList from "./DropdownList";

const DropdownListGroup = ({
  fields = [],              // [{ name, label, value, options, placeholder, width, ... }]
  onChange,                 // (fieldName, newValue)
  orientation = "vertical", // "vertical" ou "horizontal"
  disabled = false,
  gap = theme.spacing.md,
  style = {},
}) => {
  const isHorizontal = orientation === "horizontal";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isHorizontal ? "row" : "column",
        gap,
        width: "100%",
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? "not-allowed" : "default",
        ...style,
      }}
    >
      {fields.map((field, index) => (
        <div
          key={field.name ?? index}
          style={{
            width: isHorizontal ? (field.width ?? "100%") : "100%",
            minWidth: field.minWidth ?? undefined,
          }}
        >
          <DropdownList
            label={field.label}
            options={field.options}
            value={field.value}
            placeholder={field.placeholder}
            disabled={disabled}
            colorCategory={field.colorCategory}
            width={field.width ?? "100%"}
            labelPosition={field.labelPosition ?? "left"}
            labelWidth={field.labelWidth ?? null}
            onChange={(val) => !disabled && onChange(field.name, val)}
            style={{
              margin: 0,
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default DropdownListGroup;
